import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootreducers";

const store = configureStore({
  reducer: rootReducer,
});

export default store;
